import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
//import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import * as utils from 'utils'

import App from './App'
import './index.css'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false, // 네트워크 오류가 발생하면 자동으로 다시 시도할지 여부를 지정
            refetchOnMount: false, //컴포넌트가 마운트될 때 즉시 데이터를 다시 가져오도록 설정
            refetchInterval: false, // 쿼리가 자동으로 주기적으로 다시 가져올 간격을 지정
            refetchOnReconnect: false, // 네트워크 연결이 다시 설정될 때(예: 오프라인에서 다시 온라인으로 전환될 때) 자동으로 쿼리를 다시 가져올지 여부를 지정
            refetchOnWindowFocus: false, // 브라우저 창이 다시 포커스될 때 자동으로 쿼리를 다시 가져올지 여부를 지정
            refetchIntervalInBackground: false, // 백그라운드에서 실행 중인 상태에서도 주기적으로 쿼리를 다시 가져올지 여부를 지정
            //네트워크 에러없이 성공시
            onSuccess: data => {
                const apiResponse = data

                if (apiResponse?.code === utils.API_CODE.FAIL) {
                    alert('[' + apiResponse?.code + ']' + apiResponse?.message)
                } else if (apiResponse?.code === utils.API_CODE.AUTH_FAIL) {
                    alert('[' + apiResponse?.code + ']' + apiResponse?.message)
                    window.parent.location.href = process.env.REACT_APP_LOGIN_URL
                } else if (apiResponse?.code === utils.API_CODE.SUCCESS) {
                    // console.log('성공', data)
                } else {
                    alert('[' + apiResponse?.code + ']' + apiResponse?.message)
                }
            },
            // 네트워크 에러시
            onError: error => {
                alert('사이트 관리자에게 문의 해 주세요')
                console.log('네트워크 에러', error.message, error.response.data.message)
            },
        },
        mutations: {
            // 네트워크 에러없이 성공시
            onSuccess: (data, variables, context) => {
                const apiResponse = data
                console.log('apiResponse : ', apiResponse)
                if (apiResponse && apiResponse?.code === utils.API_CODE.FAIL) {
                    alert(apiResponse?.message)
                } else if (apiResponse?.code === utils.API_CODE.SUCCESS) {
                    // console.log('성공', data)
                } else {
                    alert(apiResponse?.message)
                }
            },
            onError: error => {
                alert('사이트 관리자에게 문의 해 주세요')
                console.log('error:::', error)
            },
        },
    },
})

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </QueryClientProvider>,
)

//reportWebVitals()
